import find from 'lodash/find';
import Link from '@nexus/fff-ui-shared/Link';
import env from './env';

export const PUBLIC_SHOP = 'PUBLIC_SHOP';
export const COUNTRY_ISO_CODE = 'US';

export const CADENCE_TYPE = {
  NINETY_DAYS: 'NINETY_DAYS',
};

export const CADENCE_VERBOSE_STRING = {
  NINETY_DAYS: '3 months',
};

export const BATCH_RENEWAL_COMPONENT_CONTEXT = {
  checkout: 'checkout',
  accordion: 'accordion',
};

export const PRODUCT_PURCHASE_OPTIONS = {
  ONE_TIME: 'oneTime',
  SAVE_SUBSCRIBE: 'saveSubscribe',
};

export const SEGMENT_PRODUCT_TYPE = {
  intro: 'Intro Product',
  refill: 'Public Sub',
};

export const checkBatchRenewal = (subscribableProducts, cadenceType) => {
  const existingSub = find(
    subscribableProducts,
    (product) => product.activeSubscription?.cadenceType === cadenceType
  );
  return existingSub?.activeSubscription?.nextRenewalDate || null;
};

export const getCadenceType = (
  quantity: number,
  cadenceTypeInCart: string | null,
  productPurchaseOption: string | undefined,
  isSubscriptionAvailable: boolean,
  hasActiveSubscription: boolean
): string | null => {
  if (quantity > 0) return cadenceTypeInCart;
  // set cadenceType = NINETY_DAYS if the subscription is available
  // and has not an active subscription (cart)
  // OR the selected option is Subscribe & Save (accordion)
  return (!productPurchaseOption &&
    isSubscriptionAvailable &&
    !hasActiveSubscription) ||
    productPurchaseOption === PRODUCT_PURCHASE_OPTIONS.SAVE_SUBSCRIBE
    ? CADENCE_TYPE.NINETY_DAYS
    : null;
};

const REFILLS_CATEGORY_ID = {
  dev: 34,
  prod: 444,
};

export const SUBSCRIBE_AND_SAVE_LIST_DATA = [
  {
    iconClass: 'fal fa-mouse-pointer',
    title: 'Choose',
    detail: (
      <>
        Pick{' '}
        <Link
          href={`https://${env.hostname}/shop?category=${
            REFILLS_CATEGORY_ID[env.appEnv]
          }`}
          text="subscriptions"
          fontSize={14}
        />{' '}
        products from all categories, including surprise bundles.
      </>
    ),
  },
  {
    iconClass: 'fal fa-sync',
    title: 'Subscribe',
    detail:
      'Get auto-deliveries every 3 months or ship with your seasonal box.',
  },
  {
    iconClass: 'fal fa-piggy-bank',
    title: 'Bundle & Save',
    detail:
      'Bundle multiple subscriptions and get free shipping on orders over $50 in contiguous US.',
  },
];

// get variant data from subscription or campaign data
export const getVariantData = (
  selectedVariant,
  campaignProductData,
  isSubscriptionAvailable
) => {
  if (isSubscriptionAvailable) {
    const {
      subscription: { retailPrice, salePrice, percentOff, soldOut, sku },
    } = selectedVariant;
    return {
      retailPrice,
      salePrice,
      percentOff,
      soldOut,
      sku,
    };
  }
  if (campaignProductData) {
    const { price, salePrice, percentOff, soldOut, sku, subscribable } =
      campaignProductData;
    if (subscribable) {
      return {
        retailPrice: price,
        salePrice,
        percentOff,
        soldOut,
        sku,
      };
    }
  }
  const { retailPrice, percentOff, sku } = selectedVariant;
  return {
    retailPrice: Number(retailPrice / 100).toString(), // retailPrice is in cents
    salePrice: null,
    percentOff,
    soldOut: false,
    sku,
  };
};
